import { Injectable } from "@angular/core";
import {
  DocumentStoreActions,
  DocumentStoreSelectors,
  DocumentStoreReducer,
} from "./index";
import { Store } from "@ngrx/store";
import { LandTitleRegisterDto } from '@cradua/data';

@Injectable()
export class DocumentFacade {
  constructor(
    private store: Store<DocumentStoreReducer.DocumentPartialState>,
  ) {}


  isLoadingDocumentById(id: any) {
    this.store.dispatch(
      DocumentStoreActions.loadAcquisitionDocument({id}),
);
    return this.store.select(DocumentStoreSelectors.loadingDocumentRecord);
  }

 get isLoadingDocument() {
    return this.store.select(DocumentStoreSelectors.loadingDocumentRecord);
  }

  get loadDocument() {
    return this.store.select(DocumentStoreSelectors.getAllDocumentRecords);
  }

   loadClearDocument() {
    this.store.dispatch(DocumentStoreActions.loadClearAcquisitionDocument());
    return this.store.select(DocumentStoreSelectors.getAllDocumentRecords);
  }


  uploadDocumentWithFile(type: string, files: any) {
    files.forEach((doc) => {
      const { file, ...document } = doc;
      this.store.dispatch(
        DocumentStoreActions.documentUploadRequest({ file, document }),
      );
    });
  }

  uploadSingleDocumentWithFile(document: any, file: any) {
      this.store.dispatch(
        DocumentStoreActions.documentUploadRequest({ file, document }),
      );

  }

  addAcquisitionDocument(newDocument: LandTitleRegisterDto[]) {
    this.store.dispatch(
      DocumentStoreActions.addAcquisitionDocument({
        newDocument,
      }),
    );

    return this.store.select(DocumentStoreSelectors.loadingDocumentRecord);
  }

  completed() {
    return this.store.select(
      DocumentStoreSelectors.selectUploadFileCompleted,
    );
  }

  started() {
    return this.store.select(
      DocumentStoreSelectors.selectUploadFileStarted,
    );
  }

  progress() {
    return this.store.select(
      DocumentStoreSelectors.selectUploadFileProgress,
    );
  }

  error() {
    return this.store.select(DocumentStoreSelectors.selectUploadFileError);
  }

  isInProgress() {
    return this.store.select(
      DocumentStoreSelectors.selectUploadFileInProgress,
    );
  }

  isReady() {
    return this.store.select(DocumentStoreSelectors.selectUploadFileReady);
  }

  hasFailed() {
    return this.store.select(DocumentStoreSelectors.selectUploadFileFailed);
  }

  resetUpload() {
    this.store.dispatch(DocumentStoreActions.documentUploadReset());
  }

  cancelUpload() {
    this.store.dispatch(DocumentStoreActions.documentUploadCancel());
  }
}
